import { render, staticRenderFns } from "./OptOutList.vue?vue&type=template&id=e9b24252&"
import script from "./OptOutList.vue?vue&type=script&lang=js&"
export * from "./OptOutList.vue?vue&type=script&lang=js&"
import style0 from "./OptOutList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports